<template>
  <el-dialog
    :title="$t('audioSettings.title')"
    :visible.sync="info.show"
     :append-to-body="true"
    :close-on-click-modal="false"
    width="680px"
    :modal="false"
    class="audioSetting"
  >
    <div class="middles">
      <div class="audioMode">
        <div class="tipsContent">
          <div class="tips">{{ $t('audioSettings.audioFormat') }}</div>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              <p>{{ $t('audioSettings.audioOutput') }}</p>
              <p>{{ $t('audioSettings.selectTips') }}</p>
            </div>
            <i class="iconfont icon-help2" style="color: #909090"></i>
          </el-tooltip>
        </div>
        <el-radio-group v-model="audioMode" @change="onAudioModeChange">
          <el-radio label="mono">{{ $t('audioSettings.mono') }}</el-radio>
          <el-radio label="stereo">{{ $t('audioSettings.stereo') }}</el-radio>
        </el-radio-group>
      </div>

      <div class="audioQuality">
        <div class="tips">{{ $t('audioSettings.audioQuality') }}</div>
        <el-select
          v-model="audioProfile"
          :popper-append-to-body="false"
          placeholder="Select Audio Profile"
        >
          <el-option
            v-for="profile in profiles"
            :key="profile.value"
            :label="profile.text"
            :value="profile.value"
          />
        </el-select>
      </div>

      <div class="threeASetting">
        <div class="tipsContent">
          <div class="tips">{{ $t('audioSettings.noisTips') }}</div>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">
              <p>{{ $t('audioSettings.stereoNoOptions') }}</p>
              <p>{{ $t('audioSettings.audioOptions')}}</p>
            </div>
            <i class="iconfont icon-help2" style="color: #909090"></i>
          </el-tooltip>
        </div>
        <div class="content" v-for="(label, index) in aecOptions" :key="index">
          <el-checkbox
            v-if="audioMode === 'mono'"
            v-model="checkedOptions[label.key]"
            :disabled="audioMode === 'stereo'"
            @change="(val) => saveOperation(label.key, val)"
          >
            {{ label.text }}
          </el-checkbox>
          <el-checkbox
            v-else
            value="false"
            :disabled="true"
          >
            {{ label.text }}
          </el-checkbox>
          <span class="contentDetail">{{ label.detail }}</span>
        </div>
      </div>
    </div>

    <span slot="title" class="el-dialog__header">
      <i style="font-size:20px;">{{ $t('audioSettings.title') }}</i>
    </span>
    <span slot="footer" class="dialog-footer">
      <a class="cancel" @click="cancelAdvanced()">{{ $t('audioSettings.cancel') }}</a>
      <el-button class="save" @click="closeAdvanced()">
        {{ $route.name != 'coordinationParticipate' ? $t('audioSettings.save') : $t('audioSettings.refreshSave') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  watch: {
    audioInfo: {
      immediate: true,
      handler (newValue) {
        const currentPartyCode = this.info.userInfo.originPartyCode
        const currentEventId = this.info.userInfo.previewEventInfo?.id
        const storageKey = `audioSettings_${currentPartyCode}_${currentEventId}`
        const localData = localStorage.getItem(storageKey) && JSON.parse(localStorage.getItem(storageKey))
        if (localData && this.$route.name == 'preview') {
          this.getAudioSetting(localData)
        } else {
          this.getData(newValue)
        }
      }
    }
  },
  props: {
    audioInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      checkedAec: true,
      checkedAns: true,
      checkedAgc: true,
      checkedOptions: {
        checkedAec: true,
        checkedAns: true,
        checkedAgc: true
      },
      audioMode: 'mono',
      audioProfile: 'high_quality'
    }
  },
  computed: {
    ...mapState({
      State: (state) => state,
      eventInfo: state => state.eventInfo
    }),
    // 参数列表
    // https://doc.shengwang.cn/api-ref/rtc/javascript/globals#audioencoderconfigurationpreset
    profiles () {
      return this.audioMode === 'mono'
        ? [
            { text: 'Speech Low Quality (Rate 16Khz,Bitrate 24Kbps)', value: 'speech_low_quality' },
            { text: 'Speech Standard (Rate 32Khz,Bitrate 24Kbps)', value: 'speech_standard' },
            { text: 'Music Standard (Rate 48Khz,Bitrate 32Kbps)', value: 'music_standard' },
            { text: 'High Quality (Rate 48Khz,Bitrate 128Kbps)', value: 'high_quality' }
          ]
        : [
            { text: 'Standard Stereo (Rate 48Khz,Bitrate 64Kbps)', value: 'standard_stereo' },
            { text: 'High Quality Stereo (Rate 48Khz,Bitrate 192Kbps)', value: 'high_quality_stereo' }
          ];
    },
    aecOptions () {
      return [
        { key: 'checkedAec', text: this.$t('coordinationParticipant.openAEC'), detail: this.$t('coordinationParticipant.aecDetail') },
        { key: 'checkedAns', text: this.$t('coordinationParticipant.openANS'), detail: this.$t('coordinationParticipant.ansDetail') },
        { key: 'checkedAgc', text: this.$t('coordinationParticipant.openAGC'), detail: this.$t('coordinationParticipant.agcDetail') }
      ];
    }
  },
  methods: {
    applySetting (storedSettings, userSettingItem, settingKey) {
      const storedValue = storedSettings?.settings?.[settingKey]// pip 时间戳 和 value
      const userUpdateTime = userSettingItem?.updateTime || 0 // host 时间戳
      if (storedValue) {
        // 时间戳比较逻辑
        if (storedValue?.timestamp && storedValue.timestamp > userUpdateTime) {
          this[settingKey] = storedValue.value
        } else if (userSettingItem) {
          this[settingKey] = userSettingItem.value === 'true'
        }
      } else {
        this[settingKey] = userSettingItem.value === 'true'
      }
    },
    async getAudioSetting (localData) {
      try {
        const storedData = localData
        const userSettings = this.info.userInfo.previewEventInfo?.userSettings || []
        userSettings && userSettings.forEach(item => {
          switch (item.name) {
            case 'audioAec':
              this.checkedAec = item.value === 'true'
              this.applySetting(storedData, item, 'checkedAec', item)
              break
            case 'audioAns':
              this.checkedAns = item.value === 'true'
              this.applySetting(storedData, item, 'checkedAns', item)
              break
            case 'audioAgc':
              this.checkedAgc = item.value === 'true'
              this.applySetting(storedData, item, 'checkedAgc', item)
              break
          }
        })
        this.audioQualityPreset = storedData?.audioQualityPreset
        // 最终的值
        const audioInfo = {
          checkedAec: this.checkedAec,
          checkedAns: this.checkedAns,
          checkedAgc: this.checkedAgc,
          audioQualityPreset: this.audioQualityPreset
        }
        this.getData(audioInfo)
      } catch (error) {
        console.error('加载音频设置失败:', error)
      }
    },
    // 初始化获取三A及音频质量设置
    // 默认情况下需要将Ans打开
    async getData (audioInfo) {
      this.checkedOptions.checkedAec = audioInfo?.checkedAec
      this.checkedOptions.checkedAns = audioInfo?.checkedAns
      this.checkedOptions.checkedAgc = audioInfo?.checkedAgc
      this.audioProfile = audioInfo?.audioQualityPreset || 'high_quality'

      if (!this.checkedOptions.checkedAec && !this.checkedOptions.checkedAns && !this.checkedOptions.checkedAgc &&
          (this.audioProfile === 'standard_stereo' || this.audioProfile === 'high_quality_stereo')) {
        this.audioMode = 'stereo'
      } else {
        this.audioMode = 'mono'
      }
    },
    saveOperation (key, val) {
      this.checkedOptions[key] = val
    },
    onAudioModeChange (newMode) {
      this.audioMode = newMode
      // 切换音频模式时，
      // 单声道的音频质量，默认为 high_quality
      // 立体声的音频质量，默认为 standard_stereo
      if (newMode === 'stereo') {
        this.audioProfile = 'standard_stereo'
      } else {
        this.audioProfile = 'high_quality'
        const userSettings = this.info.userInfo.eventInfo?.userSettings || []
        userSettings && userSettings.forEach(item => {
          switch (item.name) {
            case 'audioAec':
              this.checkedOptions.checkedAec = item.value === 'true'
              break
            case 'audioAns':
              this.checkedOptions.checkedAns = item.value === 'true'
              break
            case 'audioAgc':
              this.checkedOptions.checkedAgc = item.value === 'true'
              break
          }
        })
      }
    },
    cancelAdvanced () {
      this.info.show = false
    },
    changeAudioSetting (value) {
      const params = [
        {
          mark: this.info.userInfo.rtilCode + '',
          annotation: this.info.userInfo.partyCode,
          key: 'audioSettings',
          value,
          notify: true
        }
      ]
      this.$http.post(`${this.State.config.urlInfo.partyline}/partyline-backend/behavior/noLogin/setList`, params)
        .then((res) => {
          if (res.data.errorCode === '0x0') {
            if (this.$route.name == 'coordination') {
              this.$message.success(this.$t('audioSettings.refreshPage'))
            }
          }
        })
    },
    closeAdvanced () {
      const timestamp = Date.now()
      // 根据音频模式确定复选框值
      const getCheckedValue = (key) =>
        this.audioMode === 'mono' ? this.checkedOptions[key] : false
      const audioSettings = {
        settings: {
          checkedAec: { value: getCheckedValue('checkedAec'), timestamp },
          checkedAns: { value: getCheckedValue('checkedAns'), timestamp },
          checkedAgc: { value: getCheckedValue('checkedAgc'), timestamp }
        },
        timestamp,
        audioQualityPreset: this.audioProfile
      }
      // 1.如果不是在preview页面则通过behavior存储
      // 2.如果是在preview页面且拥有rtilCode(加入过会议)则通过behavior存储
      // 3.如果是在在preview页面且没有rtilCode(没有加入过会议)则存储在本地
      if (this.info.userInfo.rtilCode) {
        this.changeAudioSetting(JSON.stringify(audioSettings))
      } else {
        // 生成动态存储键名
        const currentPartyCode = this.info.userInfo.originPartyCode
        const currentEventId = this.info.userInfo.previewEventInfo?.id
        const storageKey = `audioSettings_${currentPartyCode}_${currentEventId}`
        localStorage.setItem(storageKey, JSON.stringify(audioSettings))
      }
      this.info.show = false
      if (this.$route.name === 'coordinationParticipate') {
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.audioSetting{
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: hidden;
  /deep/.el-dialog {
    background: #28282e;
    .el-icon-close{
    display:none;
    }
    .el-dialog__header{
    padding:32px 20px 10px 19px;
    }
    .dialog-footer {
    a {
      color: #999;
      margin-left: 30px;
      cursor: pointer;
    }
    .save {
      font-size:14px !important;
      color: #fff;
      padding: 3px 17px 5px;
      background: #03897b;
      border-radius: 5px;
      cursor: pointer;
    }
    .el-button.save {
      border: none;
      padding: 8px 8px;
      margin-left: 30px;
    }
    }
    .el-dialog__footer{
    height:60px;
    }
    .el-dialog__title {
    color: #fff;
    }
    .el-button {
    background: #03897b;
    border: #03897b;
    color: #999;
    font-size: 16px;
    }
    .el-button--primary {
    color: #fff;
    }
    .el-icon-close {
    color: #fff;
    }
    .el-dialog__body {
    color: #fff;
    font-size: 16px;
    padding-top:30px;
    padding-bottom: 15px;
    padding-left: 32px;
    padding-right: 32px;
    .middles{
      display: flex;
      flex-direction: column;
      .el-select .el-select-dropdown__item{
        text-indent:unset !important;
          &.selected {
          color: #03897b !important;
        }
      }
      .tipsContent{
          display: flex;
          margin-bottom: 16px;
          align-items: flex-end;
          .tips{
            display: contents;
          }
          i{
            margin-left: 5px;
          }
        }
      .audioMode{
        margin-bottom: 32px;
        .el-radio__input.is-checked .el-radio__inner {
          background: #454549;
          border: none;
          width: 16px;
          height: 16px;
        }
        .el-radio__inner::after {
          width: 8px;
          height: 8px;
          background-color: #454549;
          background-color: #03897b;
        }
        .el-radio__input.is-checked + .el-radio__label {
          font-size: 14px;
          font-weight: 500;
          color: #03897b;
        }
        .el-radio__inner {
          width: 16px;
          height: 16px;
          background: #454549;
          border: none;
        }
        .el-radio__input + .el-radio__label {
          font-size: 14px;
          font-weight: 500;
          color: #03897b;
        }
        }
      .audioQuality{
        display: block !important;
        margin-top: unset !important;
        margin-bottom: 32px;
        .tips{
          margin-bottom: 16px;
        }
      }
      .content,.audioQuality{
        display: flex;
        align-items: center;
        margin-top: 16px;
        .contentDetail{
          margin-left: 12px;
          color: #909090;
        }
        .el-select{
          width: 70% !important;
          .el-scrollbar__wrap {
            margin-top:9px;
            margin-bottom: 6px !important;
            margin-right: -6px !important;
            max-height: 310px;
            overflow: hidden;
          }
          .el-input__suffix{
            right: 5px !important;
          }
          .el-input{
            width: 100% !important;
            background-color: #333339 !important;
            border-radius: 4px !important;
            .el-input__inner{
              opacity: unset !important;
              padding:0 15px !important;
              background-color: #333339 !important;
            }
          }
            .el-select-dropdown__item.hover,
            .el-select-dropdown__item:hover {
              background-color: rgba(0, 0, 0, .3) !important;
            }
            .el-select-dropdown .el-select-dropdown__item.selected:after {
              right: auto !important;
              left: -5px !important;
              font-size: 18px;
              // right: -5px;
            }
            .el-select-dropdown {
              border: none;
              background: #28282e;
              margin-top: 0 !important;
              box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
              .el-scrollbar {
                display: block !important;
              }
              .el-select-dropdown__empty {
                display: none !important;
              }
            }
            .el-select-dropdown__item {
              text-indent: 20px;
              color: #f1f1f1;

              // &:hover {
              //   color: #00cc66;
              // }
              &.selected {
                color: #00cc66;
                font-weight: 700;
              }
            }
            .el-select-dropdown__list {
              padding: 0;
            }
          }
        }
      .el-checkbox {
          color:#fff !important;
          &.is-checked {
            .el-checkbox__label {
              color: #03897b;
            }
          }
          &.is-disabled {
            .el-checkbox__label {
              color: #909090;
            }
          }
          .el-checkbox__label {
            padding-left: 5px;
          }
          .el-checkbox__input {
            &.is-checked {
              .el-checkbox__inner {
                background: #03897b;
                border: 2px solid #03897b;
                &::after {
                  left: 3px;
                }
              }
            }
            &.is-disabled {
              .el-checkbox__inner {
                background: #909090;
                border: 2px solid #909090;
                &::after {
                  left: 3px;
                }
              }
            }
            .el-checkbox__inner {
              background: none;
              border: 2px solid #666;
            }
          }
        }
      .audioFeedback {
        margin-top: 24px;
        display: flex;
        align-items: center;
        .feedbackText {
          margin-left: 8px;
          margin-right: 6px;
        }
      }
    }
    }
  }
}

</style>
